module.exports = __webpack_public_path__ + "img/bannerUser.b3ad29b3.png";